const routes = [
    {
        path: '/networks',
        component: () => import('@/pages/ritualCircleNetworks/NetworkHome.vue'),
        meta: { breadCrumb: 'Ritual Circle Networks', entity: 'network' },
        children: [
            {
                path: '',
                name: 'network',
                component: () => import('@/pages/ritualCircleNetworks/NetworkList.vue'),
                meta: { breadCrumb: 'List' },
            },
            {
                path: 'archive',
                name: 'networkArchive',
                component: () => import('@/pages/ritualCircleNetworks/NetworkArchive.vue'),
                meta: { breadCrumb: 'Archive' },
            },
            {
                path: 'filter/:teamId?',
                name: 'filterNetwork',
                component: () => import('@/pages/ritualCircleNetworks/NetworkList.vue'),
                props: true,
                meta: { breadCrumb: 'Filter' },
            },
            {
                path: 'new',
                name: 'newNetwork',
                component: () => import('@/pages/ritualCircleNetworks/NetworkEditor.vue'),
                meta: { breadCrumb: 'New' },
            },
            {
                path: ':id/edit',
                name: 'editNetwork',
                component: () => import('@/pages/ritualCircleNetworks/NetworkEditor.vue'),
                props: true,
                meta: { breadCrumb: 'Edit' },
            },
            {
                path: ':id/read/:tabName?',
                name: 'readNetwork',
                component: () => import('@/pages/ritualCircleNetworks/NetworkReader.vue'),
                props: true,
                meta: { breadCrumb: 'Read' },
            },
        ],
    },
]

export default routes
